/* global axios */
// API do painel do SGP (custom/app/controllers/api/v1/accounts/conversations/sgp).
// Tudo pendurado na conversa: contato, documento e contrato saem dela no
// servidor, nunca daqui.

const base = (accountId, conversationId) =>
  `/api/v1/accounts/${accountId}/conversations/${conversationId}/neuxs/sgp`;

export const createSgpApi = (accountId, conversationId) => {
  const url = path => `${base(accountId, conversationId)}${path}`;
  return {
    estado: () => axios.get(url('')),
    salvaDocumento: documento => axios.put(url('/documento'), { documento }),
    salvaContrato: contrato => axios.put(url('/contrato'), { contrato }),
    contratos: () => axios.get(url('/contratos')),
    titulos: () => axios.get(url('/titulos')),
    promessa: data => axios.post(url('/promessa'), { data }),
    enviaTitulo: (id, formato, idempotencia) =>
      axios.post(url(`/titulos/${id}/enviar`), { formato, idempotencia }),
    servicos: () => axios.get(url('/servicos')),
    manutencoes: () => axios.get(url('/manutencoes')),
    criaManutencao: dados => axios.post(url('/manutencoes'), dados),
    finalizaManutencao: id => axios.post(url(`/manutencoes/${id}/finalizar`)),
    pops: () => axios.get(url('/pops')),
    // Texto comum na conversa, pela API de mensagens do próprio Chatwoot.
    enviaTexto: content =>
      axios.post(
        `/api/v1/accounts/${accountId}/conversations/${conversationId}/messages`,
        { content, private: false, message_type: 'outgoing' }
      ),
  };
};

// A mensagem que o backend escreveu para o operador, ou a genérica.
export const erroDaApi = (error, fallback) =>
  error?.response?.data?.erro || fallback;
